import React from "react";
import ResultAbout from "../ResultChart/ResultAbout";
import './LeftTExt.css';
import { formatDecimal } from "../../helpers/utils";

function formatNumber(num) {
    if (num % 1 !== 0) {
        return formatDecimal(num);
    } else {
        return parseInt(num);
    }
}


function LeftTextAdditionalInfo({ data }) {
    let P0_pa = Math.round(data.P0 / 10), // dPa to Pa
        P0_mmhg = Math.round(data.P0 * 0.000750062), // dPa to mmHg
        PPG = data.PPG,
        R2_gscm4 = Math.round(data.R2),
        R2_wu = Math.round(data.R2 * 0.0125), // g/s/cm^4 to WU
        Q_mean_mlmin = Math.round(data.Q_mean * 60), // ml/s to ml/min,
        E_text = Math.round(data.E) + " Pa",
        M_text = Math.round(data.myocardium_mass) + " g",
        P0_text = P0_pa + " Pa (" + P0_mmhg + " mmHg)",
        R2_text = R2_gscm4 + " g/s/cm<sup>4</sup> (" + R2_wu + " WU)",
        Q_mean_text = Q_mean_mlmin + " ml/min";
    return (
        <div className="left-text-radius">
            <div className="about_g text-white">
                <ResultAbout title={"PPG"} about={PPG} />
                <ResultAbout title={"E"} about={E_text} />
                <ResultAbout title={"M"} about={M_text} />
                <ResultAbout title={"P<sub>0</sub>"} about={P0_text} />
                <ResultAbout title={"R<sub>2</sub>"} about={R2_text} />
                <ResultAbout title={"Q<sub>mean</sub>"} about={Q_mean_text} />
            </div>
        </div>
    );
}

export default LeftTextAdditionalInfo;